import React from "react";
import { useMrp } from "./useMrp";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import CloseLogo from "../../Assets/close_icon.png";
import Chart from "react-apexcharts";
import {
  formatDot,
  switchDotsAndCommas,
  numberWithCommas,
} from "../../util/utilFunction";
import MrpTable from "../../components/MrpTable/MrpTable";
import { bulan, tahun, constCustomer } from "../../util/constant";
import MrpSummaryTable from "../../components/MrpSummaryTable/MrpSummaryTable";
import MrpPendukungTable from "../../components/MrpPendukungTable/MrpPendukungTable";

const Mrp = () => {
  const {
    filterCustomer,
    setFilterCustomer,
    subMenu,
    setSubMenu,
    filterBahan,
    setFilterBahan,
    filterBulan,
    setFilterBulan,
    filterTahun,
    setFilterTahun,
    listData = {},

    popUpImportStock,
    setPopUpImportStock,
    handleExportTemplateBahanBaku,
    handleImportStockAwal,
    setFile,
    disabled,
    setDisabled,
    listDataAwal,
  } = useMrp();

  const sampleBahan = (listData?.bahanBaku || []).map((item) => ({
    value: item.material,
    label: item.material,
  }));

  const filteredData =
    !listData.groupedResult || filterBahan === "Pilih Bahan"
      ? listData.groupedResult
      : listData.groupedResult.filter(
          (item) => item.dataBarangJadi?.bahanBaku === filterBahan
        );

  return (
    <div className="container_inventory">
      {popUpImportStock ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <button
              className="export_btn_inventory"
              onClick={() => handleExportTemplateBahanBaku()}
            >
              Template
            </button>
            <select
              value={filterCustomer}
              onChange={(e) => setFilterCustomer(e.target.value)}
              className="select-customer-po"
              style={{ margin: "6px 6px 6px 0", width: "92px" }}
              defaultValue="Pilih Customer"
            >
              <option disabled>Pilih Customer</option>
              {constCustomer.map((data, i) => (
                <option value={data} key={i}>
                  {data}
                </option>
              ))}
            </select>
            <img
              className="width_edit_logo"
              src={CloseLogo}
              onClick={() => {
                setPopUpImportStock(false);
              }}
              alt="edit_logo"
            />
          </div>
          <br />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <input
              type="file"
              accept=".xls,.xlsx"
              onChange={(e) => setFile(e.target.files[0])}
              style={{
                cursor: "pointer",
                marginRight: "6px",
              }}
            />
            <button
              style={{
                cursor: "pointer",
                padding: "12px",
                color: "white",
                background: "red",
                border: "none",
                borderRadius: "6px",
                fontWeight: "bold",
              }}
              disabled={disabled}
              onClick={() => {
                setDisabled(true);
                handleImportStockAwal();
              }}
            >
              Import
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      <p className="title_inventory">Material Requirement Planning</p>
      <div className="wrapper_sub_menu_history">
        <p
          className={
            subMenu === "Forecast"
              ? "sub_menu_history border_active_history"
              : "sub_menu_history"
          }
          style={{ marginTop: "0px" }}
          onClick={() => setSubMenu("Forecast")}
        >
          Forecast
        </p>
        {/* <p
          className={
            subMenu === "Penggunaan"
              ? "sub_menu_history border_active_history"
              : "sub_menu_history"
          }
          style={{ marginTop: "0px" }}
          onClick={() => setSubMenu("Penggunaan")}
        >
          Penggunaan
        </p> */}
        <p
          className={
            subMenu === "Stock Awal"
              ? "sub_menu_history border_active_history"
              : "sub_menu_history"
          }
          style={{ marginTop: "0px" }}
          onClick={() => setSubMenu("Stock Awal")}
        >
          Stock Awal
        </p>
      </div>

      {subMenu !== "Stock Awal" ? (
        <div
          style={{ display: "flex", marginBottom: "12px", flexWrap: "wrap" }}
        >
          <select
            value={filterCustomer}
            onChange={(e) => setFilterCustomer(e.target.value)}
            className="select-customer-po"
            style={{ margin: "6px 6px 6px 0", width: "92px" }}
            defaultValue="Pilih Customer"
          >
            <option disabled>Pilih Customer</option>
            {constCustomer.map((data, i) => (
              <option value={data} key={i}>
                {data}
              </option>
            ))}
          </select>

          <select
            value={filterBahan}
            onChange={(e) => setFilterBahan(e.target.value)}
            className="select-customer-po"
            style={{ margin: "6px 6px 6px 0", width: "92px" }}
            defaultValue="Pilih Bahan"
          >
            <option disabled>Pilih Bahan</option>
            {sampleBahan.map((data, i) => (
              <option value={data.value} key={i}>
                {data.label}
              </option>
            ))}
          </select>
          <select
            className="select-customer-po"
            style={{ margin: "6px 6px 6px 0", width: "92px" }}
            value={filterBulan}
            onChange={(e) => setFilterBulan(e.target.value)}
          >
            <option disabled>Pilih Bulan</option>
            {bulan.map((ele) => (
              <option value={ele.value}>{ele.name}</option>
            ))}
          </select>
          <select
            style={{ margin: "6px 6px 6px 0", width: "56px" }}
            value={filterTahun}
            className="select-customer-po"
            onChange={(e) => setFilterTahun(e.target.value.toString())}
          >
            <option disabled>Pilih Tahun</option>
            {tahun.map((ele) => (
              <option value={ele}>{ele}</option>
            ))}
          </select>
        </div>
      ) : (
        ""
      )}
      {subMenu === "Forecast" ? (
        <>
          {listData.groupedResult === undefined ? (
            <p style={{ marginTop: "12px" }}>Memuat data...</p>
          ) : (
            <>
              <MrpTable data={filteredData} />
              <MrpSummaryTable
                data={listData?.groupedResult || []}
                filterBahan={filterBahan}
                sampleBahan={sampleBahan}
              />
              <MrpPendukungTable data={filteredData} />
            </>
          )}
        </>
      ) : subMenu === "Stock Awal" ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <div>
              <select
                value={filterCustomer}
                onChange={(e) => setFilterCustomer(e.target.value)}
                className="select-customer-po"
                style={{ margin: "6px 6px 6px 0", width: "92px" }}
                defaultValue="Pilih Customer"
              >
                <option disabled>Pilih Customer</option>
                {constCustomer.map((data, i) => (
                  <option value={data} key={i}>
                    {data}
                  </option>
                ))}
              </select>
              <select
                className="select-customer-po"
                style={{ margin: "6px 6px 6px 0", width: "92px" }}
                value={filterBulan}
                onChange={(e) => setFilterBulan(e.target.value)}
              >
                <option disabled>Pilih Bulan</option>
                {bulan.map((ele) => (
                  <option value={ele.value}>{ele.name}</option>
                ))}
              </select>
              <select
                style={{ margin: "6px 6px 6px 0", width: "56px" }}
                value={filterTahun}
                className="select-customer-po"
                onChange={(e) => setFilterTahun(e.target.value.toString())}
              >
                <option disabled>Pilih Tahun</option>
                {tahun.map((ele) => (
                  <option value={ele}>{ele}</option>
                ))}
              </select>
            </div>
            <button
              className="export_btn_inventory"
              style={{ background: "#9d8854" }}
              onClick={() => setPopUpImportStock(true)}
            >
              Import Stock Awal
            </button>
          </div>
          <br />
          <table style={{ width: "100%" }}>
            <tr>
              <th>No.</th>
              <th>Material</th>
              <th>Jumlah</th>
            </tr>
            {listDataAwal &&
              listDataAwal.map((ele, index) => (
                <tr
                  style={
                    index % 2 === 0
                      ? {
                          background: "white",
                        }
                      : {
                          background: "#f2f2f2",
                        }
                  }
                >
                  <td style={{ padding: "12px" }}>{index + 1}.</td>
                  <td style={{ padding: "12px", textAlign: "left" }}>
                    {ele.material}
                  </td>
                  <td style={{ padding: "12px" }}>
                    {formatDot(
                      switchDotsAndCommas(numberWithCommas(ele.weight))
                    )}
                  </td>
                </tr>
              ))}
          </table>
        </>
      ) : (
        ""
      )}
    </div>
  );
};
export default Mrp;
